import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { posthogkeys } from './constants';
import {environment } from '../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class PosthogService {

  constructor() {
    posthog.init(environment.postHogKey, {
      api_host: posthogkeys.apiHost,
      autocapture: false,
      disable_session_recording: false,
      capture_pageview: true,
      capture_pageleave: true
    });
  }
  capture(event: string, properties?: any) {
    if (event === '$pageleave' || event === '$web_vitals') {
      return;
    }
    const filteredProperties = this.filterSensitiveProperties(properties); 
    posthog.capture(event, filteredProperties);
  }
  identify(userId: string, properties?: any) {
    const filteredProperties = this.filterSensitiveProperties(properties);
    posthog.identify(userId, filteredProperties);
  }
  reset() {
    posthog.reset();
  }
  private filterSensitiveProperties(properties: any): any {
    if (!properties) {
      return undefined;
    }
    const { latitude, longitude, ...safeProperties } = properties;
    return safeProperties;
  }
}
